import { convertDate } from './convert-date.function';
import { offsetDateToUtc } from './offset-date-utc.function';

export const graceTime = 12 * 60 * 60 * 1000;

export function normalizeDate(date: string | Date) {
  const dateObj = convertDate(date);
  const normalizedDate = new Date(dateObj.toISOString().split('T')[0]);

  return normalizedDate;
}

export function offsetMinDate(date: Date, isGracePeriod?: boolean) {
  return offsetMinMaxDate(date, isGracePeriod ? -1 : 0);
}

export function offsetMaxDate(date: Date, isGracePeriod?: boolean) {
  return offsetMinMaxDate(date, isGracePeriod ? 1 : 0);
}

function offsetMinMaxDate(date: Date, graceFactor: number) {
  return offsetDateToUtc(new Date(date.getTime() + graceTime * graceFactor));
}
